export default __webpack_public_path__ + "static/media/pantry1-afterH-2048w.9fd35667.webp";